import React, { useContext, useEffect, useState } from "react";
import mainContext from "../context/mainContext";
import ThemeContext from "../context/themeContext";
import parse from "html-react-parser";
export default function MyPurpose() {
  const ctxtheme = useContext(ThemeContext);
  const ctxmain = useContext(mainContext);

  return (
    <div
      style={{
        background: `rgba(0,0,107, 0.9)`,
        marginTop: "5px",
        padding: "5px 5px 5px 10px",
        width: "100%",
      }}
    >
      {typeof ctxmain.purpose == "string" && parse(ctxmain.purpose)}
    </div>
  );
}
